import React, { useState } from "react";
import { GrBottomCorner, GrTopCorner } from "react-icons/gr";

const InputNumberInc = ({ placeholder, text }) => {
	const [value, setValue] = useState(placeholder);

	const toggleValue = (e) => {
		setValue(value + e);
		if (value <= 0) {
			setValue(1);
		}
	};

	return (
		<div className="form-group form--group pt-md-4">
			<div class="input-group">
				{text && (
					<span class="input-group-text">
						<span>{text}</span>
					</span>
				)}
				<input
					type="number"
					placeholder={placeholder}
					className="form-control form--control"
					min={0}
					value={value}
					onChange={(e) => setValue(e.target.value)}
				/>
				<span class="input-group-text">
					<span className="top-arrow" onClick={() => toggleValue(+1)}>
						<span>
							<GrTopCorner />
						</span>
					</span>
					<span className="bottom-arrow" onClick={() => toggleValue(-1)}>
						<span>
							<GrBottomCorner />
						</span>
					</span>
				</span>
			</div>
		</div>
	);
};

export default InputNumberInc;
